import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ArrowIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      width="16px"
      height="16px"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M8.45479 12.7306L3.26934 7.54515C2.95507 7.23088 2.95507 6.91661 3.26934 6.60234C3.58361 6.28807 3.89788 6.28807 4.21215 6.60234L9.3976 11.7878C9.71187 12.1021 9.71187 12.4163 9.3976 12.7306C9.08333 13.0449 8.76906 13.0449 8.45479 12.7306Z"
        fill="currentColor"
      />
      <path
        d="M9.3976 2.21215L4.21215 7.3976C3.89788 7.71187 3.58361 7.71187 3.26934 7.3976C2.95507 7.08333 2.95507 6.76906 3.26934 6.45479L8.45479 1.26934C8.76906 0.955065 9.08333 0.955065 9.3976 1.26934C9.71187 1.58361 9.71187 1.89788 9.3976 2.21215Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(ArrowIcon);
